import { render, staticRenderFns } from "./RegisterCellOnly.vue?vue&type=template&id=39bb1f22&scoped=true&"
import script from "./RegisterCellOnly.vue?vue&type=script&lang=ts&"
export * from "./RegisterCellOnly.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39bb1f22",
  null
  
)

export default component.exports